import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { LoginService } from '../service/login.service';
import { SharedFunctionService } from '../service/shared.function.service';

@Injectable({
  providedIn: 'root',
})
export class HomeRedirectGuard {
  private router = inject(Router);
  loginService = inject(LoginService);
  private sharedFunction = inject(SharedFunctionService);

  canActivate(): boolean {
    if (this.sharedFunction.isKiwimonsterDomain() && !this.loginService.isLogin()) {
      this.router.navigate(['/km/home']);
      return false;
    }

    return true;
  }
}
